// Analytics configuration
export const analyticsConfig = {
  // Google Analytics 4 Measurement ID
  gaMeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID!,
  
  // Environment
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  
  // Debug mode
  debug: process.env.NODE_ENV === 'development',
  
  // Tracking settings
  trackPageViews: true,
  trackFormSubmissions: true,
  trackUserInteractions: true,
  trackErrors: true,
  trackConversions: true,
};

// Initialize analytics when the app starts
export const initializeAnalytics = () => {
  if (typeof window !== 'undefined' && analyticsConfig.gaMeasurementId !== 'G-8TJEKY641J') {
    // Update the GA script with the actual measurement ID
    const script = document.querySelector('script[src*="googletagmanager.com"]') as HTMLScriptElement;
    if (script) {
      script.src = script.src.replace('G-8TJEKY641J', analyticsConfig.gaMeasurementId);
    }
    
    // Update the config
    if (window.gtag) {
      window.gtag('config', analyticsConfig.gaMeasurementId);
    }
  }
};
